import { useEffect, useState } from "react"
import Loading from "../../../components/Loading";

function NFTLinks() {
    return (
        <div>
            <ul>
            <li><a style={{'color':'white','text-decoration':'none'}} href={"https://nftnow.com/guides/bored-ape-yacht-club-guide/"}>https://nftnow.com/guides/bored-ape-yacht-club-guide/</a></li>
            <li><a style={{'color':'white','text-decoration':'none'}} href={'https://nftevening.com/bored-ape-yacht-club-bayc-roadmap-2-0-everything-we-know-so-far/'}>https://nftevening.com/bored-ape-yacht-club-bayc-roadmap-2-0-everything-we-know-so-far/</a></li>
            <li><a style={{'color':'white','text-decoration':'none'}} href={'https://www.benzinga.com/money/celebrities-that-own-bored-ape-yacht-club-nfts/'}>https://www.benzinga.com/money/celebrities-that-own-bored-ape-yacht-club-nfts/</a></li>
            <li><a style={{'color':'white','text-decoration':'none'}} href={'https://www.newsnow.com/us/Business/Cryptocurrencies/Bored+Apes'}>https://www.newsnow.com/us/Business/Cryptocurrencies/Bored+Apes</a></li>
            <li><a style={{'color':'white','text-decoration':'none'}} href={'https://beincrypto.com/learn/bored-ape-yacht-club-bayc/'}>https://beincrypto.com/learn/bored-ape-yacht-club-bayc/</a></li>
            </ul>
        </div>
    )
}

export default NFTLinks;